import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { packages as mockPackages } from '../mock';
import { getPackages } from '../api';
import { Check } from 'lucide-react';

const Pricing = () => {
  const { t, pick, dir } = useLang();
  const [packages, setPackages] = useState(mockPackages);

  useEffect(() => {
    getPackages().then((d) => d && d.length && setPackages(d)).catch(() => {});
  }, []);
  return (
    <div className="pt-28 pb-16" dir={dir}>
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#2563eb] mb-4">— {t('nav.pricing')} —</div>
          <h1 className="font-display text-5xl md:text-6xl text-[#0a0a0a]">{t('pricing.title')}</h1>
          <p className="mt-4 text-[#111827]/60 max-w-2xl mx-auto">{t('pricing.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {packages.map((p) => (
            <div key={p.id} className={`glass-card rounded-2xl p-8 relative transition-all hover:-translate-y-1 ${p.popular ? 'border-[#2563eb]/50 shadow-[0_0_50px_rgba(201,164,92,0.18)]' : ''}`}>
              {p.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-gradient-to-r from-[#2563eb] to-[#1d4ed8] text-[#f8fafc] text-[10px] uppercase tracking-widest font-semibold">
                  {t('pricing.popular')}
                </div>
              )}
              <div className="text-xs uppercase tracking-[0.2em] text-[#2563eb] mb-2">{pick(p.tagline)}</div>
              <h3 className="font-display text-3xl text-[#0a0a0a] mb-6">{pick(p.name)}</h3>
              <div className="flex items-baseline gap-2 mb-2">
                <span className="text-xs text-[#111827]/50">{t('pricing.currency')}</span>
                <span className="font-display text-5xl gold-text">{p.price.toLocaleString()}</span>
              </div>
              <div className="text-xs text-[#111827]/50 mb-8">{t('pricing.per_year')}</div>
              <div className="text-xs uppercase tracking-widest text-[#2563eb] mb-3">{t('pricing.includes')}</div>
              <ul className="space-y-2.5 mb-8">
                {pick(p.features).map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-[#111827]/80">
                    <Check className="w-4 h-4 text-[#2563eb] mt-0.5 flex-shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Link to="/SetupWizard">
                <Button className={`w-full rounded-md h-11 text-sm ${p.popular ? 'gold-button' : 'ghost-button bg-transparent'}`}>{t('pricing.choose')}</Button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;
